export default __webpack_public_path__ + "static/share-documents-working-1d75b8ef32a9e738b2f48f0b5267abf9.jpg";